import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ThumbsUpFilledIcon, ThumbsUpOutlineIcon } from '@beef/ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * ThumbUp or Down icon with counter, highlighted on hover
 */
export default function Thumb({ isPositive, isActive, isDisabled, count, onClick }) {
  const classes = cx('thumb', {
    thumbUp: isPositive,
    thumbDown: !isPositive,
    disabled: isDisabled,
    active: isActive,
  });

  return (
    <span className={classes} onClick={!isDisabled ? onClick : null} role="button" tabIndex={0}>
      <span className={cx('iconWrap')}>
        {isActive ?
          <ThumbsUpFilledIcon size="s" className={cx('iconThumb')} />
        : <ThumbsUpOutlineIcon size="s" className={cx('iconThumb')} />}
      </span>
      <span className={cx('count')}>{count}</span>
    </span>
  );
}

Thumb.propTypes = {
  isPositive: PropTypes.bool, // if true, shows thumbs up, otherwise thumbs down
  isActive: PropTypes.bool, // if true, icon is always highlighted
  isDisabled: PropTypes.bool, // half opaque and unclickable
  count: PropTypes.number, // counter to show next to the icon
  onClick: PropTypes.func,
};
